<div class="tax-card col-12">
  <h1 class="headline">Custo de parcelamento</h1>
  @if (isFixPaymentCondition()) {
    <div class="tax-card_payment col-12">
      <h4 class="tax-card_payment_type">Crédito Parcelado</h4>
      @if (getfee()) {
        <p class="tax-card_payment_tax">{{ getfee() }}% por parcela</p>
      } @else {
        <ng-container *ngTemplateOutlet="nofees"></ng-container>
      }
    </div>
  } @else {
    @for (item of fees(); track $index) {
      <div class="tax-card_payment col-12">
        <h4 class="tax-card_payment_type">{{ item.message }}</h4>
        @if (item.fee && item.valid) {
          <p class="tax-card_payment_tax">{{ item.fee }}</p>
        } @else {
          <ng-container *ngTemplateOutlet="nofees"></ng-container>
        }
      </div>
    }
  }
  <app-button text="Entendi" class="col-12 mt-4" (click)="alertService.dismiss()"></app-button>
</div>

<ng-template #nofees>
  <p class="tax-card_payment_tax">Sem taxas</p>
</ng-template>
